import DateDisplay from '@/components/common/date-display';

type Props = {
  date: string | number;
};

export default function DateHeader({ date }: Props) {
  return (
    <div className='flex w-full justify-center py-2 select-none'>
      <DateDisplay
        className='rounded-xl bg-base-100/60 px-2 py-1 text-body2 desktop:text-sm backdrop-blur-lg'
        timestamp={date}
        ruleName='message'
      />
    </div>
  );
}
